import { render } from "./BannerSlotDetailButtonSubscribeToSlot.vue?vue&type=template&id=473cd5af&scoped=true&ts=true"
import script from "./BannerSlotDetailButtonSubscribeToSlot.vue?vue&type=script&lang=ts"
export * from "./BannerSlotDetailButtonSubscribeToSlot.vue?vue&type=script&lang=ts"

import "./BannerSlotDetailButtonSubscribeToSlot.vue?vue&type=style&index=0&id=473cd5af&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473cd5af"]])

export default __exports__